var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"com-wapper"},[_c('div',{staticClass:"wapper"},[_c('div',{staticClass:"content-header"},_vm._l((_vm.colorList),function(item,index){return _c('div',{staticClass:"list",style:({ background: item })})})),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-286e54cf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wapper/src/wapper.vue
// module id = null
// module chunks = 